// removed by extract-text-webpack-plugin
module.exports = {"list":"status-list-component__list___3r1TB","divider":"status-list-component__divider___3hBbz","list_item":"status-list-component__list_item___2WTjs","list_item_section":"status-list-component__list_item_section___2Jnhf","title":"status-list-component__title___2OSuI","status":"status-list-component__status___UQ1DU","dateTime":"status-list-component__dateTime___3-x-R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/arrival-status-list-component/status-list-component.scss
// module id = 646
// module chunks = 0